import { render } from "./FilterBarButton.vue?vue&type=template&id=4621be1e"
import script from "./FilterBarButton.vue?vue&type=script&lang=js"
export * from "./FilterBarButton.vue?vue&type=script&lang=js"
script.render = render

export default script